import axiosInstance from "./api";

export const getTermsAndConditions = async () => {
  try {
    const response = await axiosInstance.get("/terms-conditions");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPrivacyPolicy = async () => {
  try {
    const response = await axiosInstance.get("/privacy-policy");
    return response.data;
  } catch (error) {
    throw error;
  }
};
